// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xOiW","col":"styles_col__3IiJx"};